
<div
  id="pageBingo"
  class="d-flex flex-column main-bingo"
  :class="{ 'h-100': !isHauteurPageAutomatique }"
>
  <div>
    <vue-headful
      :title="metaData.title"
      :description="metaData.description"
      :keywords="metaData.keywords"
      :image="metaData.metaOGImage"
      :url="metaUrl"
      :head="{
        'meta[name=robots]': { content: metaData.metaNoIndex },
        'link[hreflang=en-ca]': { href: pathAnglais },
        'link[hreflang=fr-ca]': { href: pathFrancais },
        'link[rel=apple-touch-icon]': { type: 'image/png' },
        'link[rel=icon]': { type: 'image/png' },
      }"
    />

    <div class="w-100 h-100">
      <BingoMenu />
      <main class="d-flex align-items-center h-100 px-0 overflow-hidden">
        <EditableArea
          v-if="content.main"
          :key="componentKey"
          class="w-100 h-100"
          :content="content.main"
        />
      </main>
      <ModaleConfirmationCICL />
      <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentHeritageModalNewsletter" />
      <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentCatfish" />
      <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentNotifications" />
      <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentBanniereLaterale" />
    </div>

    <!-- Scroll-to-top button // all platforms except 'samsungbrowser' -->
    <b-link id="return-to-top" @click.prevent="mixinHelpers_smoothScrollTo()">
      <svg-icon class="icone-fleche rotation90" icon-name="fleche-lien-gauche"></svg-icon>
    </b-link>
    <footer
      v-if="isPiedDePageVisible"
      id="footer"
      class="p-0"
      :class="$isMobile ? 'compteFonce' : content.themePiedDePage"
    >
      <Heritage :key="componentKey" class="piedDePage" :content="contentHeritagePiedDePage" />
    </footer>
  </div>
</div>
